module.exports = __webpack_public_path__ + "static/img/bg.e1c7b5a.jpg";


//////////////////
// WEBPACK FOOTER
// ./static/default/img/feature/bg.jpg
// module id = oSRJ
// module chunks = 7